import { render, staticRenderFns } from "./TypeDocuments.vue?vue&type=template&id=5a71cc8d&scoped=true&"
import script from "./TypeDocuments.vue?vue&type=script&lang=ts&"
export * from "./TypeDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./TypeDocuments.vue?vue&type=style&index=0&id=5a71cc8d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71cc8d",
  null
  
)

export default component.exports